import axios from "axios";
import { API_URL } from "constants/base";

const JWT = window.sessionStorage.getItem("jwt");

const AddDoctor = async (data) => {
  return await axios
    .post(API_URL + "/auth/local/register", data, {
      headers: {
        authorization: "Bearer " + JWT,
      },
    })
    .then((response) => {})
    .catch((error) => {
      console.log("error", error);
    });
};

const getDoctors = async (data) => {
  return await axios
    .get(API_URL + "/users?_limit=10000000", {
      headers: {
        authorization: "Bearer " + JWT,
      },
    })
    .then((response) => {
      const data = response.data.filter(
        (item) => item.role.type === "authenticated"
      );
      return data;
    })
    .catch((error) => {
      console.log("error", error);
    });
};
export { AddDoctor, getDoctors };
